<template>
  <v-row>
    <v-col cols="12" lg="5" class="text-end">
      <h3 class="font-italic font-weight-light">Vor allem aber müssen wir eines <br/>
        wollen: ... die Zuschauer verführen,<br/>
        auf dass sie nüchtern oder trunken <br/>
        werden, angeregt, aufgeregt und <br/>
        angestoßen, auch durch <br/>
        Anstößiges.</h3>
      <br/>
      <p class="body-1"> August Everding</p>
    </v-col>
    <v-col cols="12" lg="5" class="mb-10">
      <h3><b>Aktuell:</b></h3><br>
      <v-img
        class="elevation-1"
        src="/Bilder/DasNeueste/Workshops2026ohneBilder.png"
        alt="Workshops Herbst 2026"
      ></v-img>
      <anwaerbung-card class="mt-10"></anwaerbung-card>
    </v-col>
  </v-row>
</template>

<script>
import AnwaerbungCard from "@/index/components/wasist/AnwaerbungsCard";

export default {
  name: "Start",
  components: {AnwaerbungCard},
  metaInfo: {
    title: "Start",
    meta: [
      {name: 'description', content: 'Was läuft bei uns aktuell'}
    ]
  }
}
</script>

<style scoped>

</style>